import { useState } from "react";
import { faqs } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-10 py-16 md:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="第一次来，你可能想知道"
            desc="如果下面没有解决你的疑惑，欢迎直接给我们发邮件，我们通常会在一两个工作日内回复。"
          />
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col gap-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "border-primary-300 bg-primary-50/40" : "border-background-200 bg-background-50"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                      <i
                        className={`${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        } w-5 h-5 flex items-center justify-center text-primary-600 shrink-0`}
                      ></i>
                    </button>
                  </h3>
                  {isOpen ? (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}